import React from 'react';

import { describeMatches, matchedFieldLabels } from 'helpers/searchMatches';

/**
 * Why a patient came back from a search.
 *
 *   full    - "Jane → first name · 07700900123 → phone number", for the table
 *   compact - "Matched by first name · phone number", for the narrow dropdown
 *
 * Renders nothing when there was no search, or nothing to explain.
 */
export default function SearchMatches({ matches, compact = false }) {
    if (compact) {
        const labels = matchedFieldLabels(matches);

        if (!labels.length) {
            return null;
        }

        return (
            <div className="text-muted font-size-11" data-testid="search-matches">
                Matched by {labels.join(' · ')}
            </div>
        );
    }

    const described = describeMatches(matches);

    if (!described.length) {
        return null;
    }

    return (
        <div className="text-muted font-size-12 mt-1" data-testid="search-matches">
            {described.map((match, index) => (
                <span key={match.term}>
                    {index > 0 ? ' · ' : ''}
                    <strong>{match.term}</strong>
                    {` → ${match.labels.join(', ')}`}
                </span>
            ))}
        </div>
    );
}
